import { ExtensionTrustSettingsService } from '../../service/extension-trust-settings.service';
import {
  RevokeTrustBtnData,
  isInstanceOfRevokeTrustBtnData,
} from '../../service/luigiConfig/custom-message-listeners/revoke-trust-btn-data';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
  inject,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '@fundamental-ngx/core/button';
import {
  CardComponent,
  CardContentComponent,
  CardListDirective,
} from '@fundamental-ngx/core/card';
import { CheckboxComponent } from '@fundamental-ngx/core/checkbox';
import { ContentDensityDirective } from '@fundamental-ngx/core/content-density';
import * as LuigiClient from '@luigi-project/client';
import { LuigiCoreService } from '@openmfp/portal-ui-lib';

@Component({
  selector: 'app-extension-trust-dialog',
  imports: [
    CardComponent,
    CardContentComponent,
    CardListDirective,
    CheckboxComponent,
    ButtonComponent,
    ContentDensityDirective,
    FormsModule,
  ],
  templateUrl: './extension-trust-dialog.component.html',
  styleUrl: './extension-trust-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class ExtensionTrustDialogComponent implements AfterContentInit, OnInit {
  checkboxValue = false;
  readonly extensionLabel = signal('');
  showDialog = false;
  trustService = inject(ExtensionTrustSettingsService);

  constructor(private luigiCoreService: LuigiCoreService) {}

  /**
   * We want to create the listener prior to receiving updates
   * from LuigiCore to be sure we receive the messages.
   *
   * Once the listener is invoked we inform LuigiCore that we're
   * ready for updates on extension data.
   */
  ngOnInit(): void {
    LuigiClient.addCustomMessageListener(
      'extension-trust.update-client',
      (message) => {
        const _message = message as Record<string, RevokeTrustBtnData>;
        if (isInstanceOfRevokeTrustBtnData(_message['data'])) {
          this.trustService.setTrustData(_message['data']);
          this.extensionLabel.set(
            this.trustService.trustData?.extensionLabel ?? '',
          );
          const projectId = this.trustService.trustData?.projectId;
          if (projectId) {
            this.showDialog = this.trustService.isTrusted(projectId);
          } else {
            console.warn(
              'Failed to show Trust Dialog because the Luigi message that triggered this listener was corrupted.',
            );
          }
        } else {
          console.error(
            `The Luigi Client for the ExtensionTrustDialog received an invalid message from LuigiCore on route 'extension-trust.update-client': ${JSON.stringify(message)}`,
          );
        }
      },
    );
    this.trustService.requestTrustDataSync();
  }

  ngAfterContentInit(): void {
    this.luigiCoreService.ux().hideAppLoadingIndicator();
  }
}
